import {IMerchantCategoryLabel, IReportTemplate} from 'app/common/interfaces/IReport';
import {ReportType} from 'app/common/enums/ReportType';
import {DateResolutionTypes} from 'app/common/enums/date-resolution-types.enum';
import {PricingEntityTypes} from 'app/common/enums/pricing-entity-type.enum';
import {PricingMarginType} from 'app/common/enums/pricing-margin-type.enum';
import {PositionOperatorType} from 'app/common/enums/PositionOperatorType.enum';
import {PricingPositionType} from 'app/common/enums/PricingPositionType.enum';
import {PricingPlanTypes} from 'app/common/enums/billing/PricingPlanTypes.enum';

export const LOGOUT = 'Log Out';
export const GoogleShoppingId = '6096d6e97ccfc76cdc71d671';

export const ColorScheme = {
  domain: ['#7A4AFF', '#3A56FC', '#AB4AFF', '#33CFFF', '#00F98E', '#DE4AFF', '#4588F4', '#46F7EE', '#00F98E', '#FF4ABD'],
};

export const GreenColorScheme = {
  domain: ['#FF2468', '#1EC1AA', '#5F6DF0', '#C8CAD6'],
};

export const GoogleShoppingVisibilityColorScheme = {
  domain: ['#FF2468', '#1EC1AA', '#5F6DF0', '#00F98E'],
};

export const PricingGapChartColorScheme = {
  domain: ['#7FDF9A', '#FF7070', '#3430F4'],
};

export const DefaultReportColumns: string[] = [
  'title',
  'brand',
  'barcode',
  'sku',
  'externalId',
  'categoryId',
  'cost',
  'price',
  'compareAtPrice',
];

export const ReportMerchantCategoryLabels: IMerchantCategoryLabel[] = [
  {
    title: 'Custom Label 0',
    googleMerchantKey: 'customLabel0',
    customFieldsKey: 'custom_label_0',
    labels: [
      { columnLabel: 'Competitiveness', columnValue: 'competitiveness' },
      { columnLabel: 'Price Gaps', columnValue: 'priceGaps' },
    ],
  },
  {
    title: 'Custom Label 1',
    googleMerchantKey: 'customLabel1',
    customFieldsKey: 'custom_label_1',
    labels: [
      { columnLabel: 'Competitiveness', columnValue: 'competitiveness' },
      { columnLabel: 'Price Gaps', columnValue: 'priceGaps' },
    ],
  },
  {
    title: 'Custom Label 2',
    googleMerchantKey: 'customLabel2',
    customFieldsKey: 'custom_label_2',
    labels: [
      { columnLabel: 'Competitiveness', columnValue: 'competitiveness' },
      { columnLabel: 'Price Gaps', columnValue: 'priceGaps' },
    ],
  },
  {
    title: 'Custom Label 3',
    googleMerchantKey: 'customLabel3',
    customFieldsKey: 'custom_label_3',
    labels: [
      { columnLabel: 'Competitiveness', columnValue: 'competitiveness' },
      { columnLabel: 'Price Gaps', columnValue: 'priceGaps' },
    ],
  },
  {
    title: 'Custom Label 4',
    googleMerchantKey: 'customLabel4',
    customFieldsKey: 'custom_label_4',
    labels: [
      { columnLabel: 'Competitiveness', columnValue: 'competitiveness' },
      { columnLabel: 'Price Gaps', columnValue: 'priceGaps' },
    ],
  },
];

export const ReportTemplates: IReportTemplate[] = [
  {
    title: 'Market Benchmark',
    reportType: ReportType.PricingCondition,
    dateResolution: DateResolutionTypes.Day,
    setPriceTo: PricingEntityTypes.AllProducts,
    margin: 5,
    marginType: PricingMarginType.Percentage,
    positionOperatorType: PositionOperatorType.Higher,
    positionType: PricingPositionType.Average,
    comparePriceTo: 'my competitors',
    columns: DefaultReportColumns,
  },
  {
    title: 'Undercut Alert',
    reportType: ReportType.PricingCondition,
    dateResolution: DateResolutionTypes.Week,
    setPriceTo: PricingEntityTypes.AllProducts,
    margin: 2,
    marginType: PricingMarginType.Percentage,
    positionOperatorType: PositionOperatorType.Lower,
    positionType: PricingPositionType.Cheapest,
    comparePriceTo: 'competitor',
    columns: DefaultReportColumns,
  },
  {
    title: 'Custom Labels Feed for GMC',
    reportTitleImageURL: 'assets/images/icons/google-merchant.svg',
    reportType: ReportType.GoogleMerchant,
    dateResolution: null,
    setPriceTo: null,
    margin: null,
    marginType: null,
    positionOperatorType: null,
    positionType: null,
    comparePriceTo: 'competitor',
    entity: 'searchableProducts',
    isPermanentLink: true,
    minPricingPlanToUse: PricingPlanTypes.Business,
    columns: ['id'],
  },
  {
    title: 'All Products Live Feed Report',
    reportType: ReportType.Entity,
    dateResolution: DateResolutionTypes.Week,
    setPriceTo: PricingEntityTypes.AllProducts,
    margin: 2,
    marginType: PricingMarginType.Percentage,
    positionOperatorType: PositionOperatorType.Lower,
    positionType: PricingPositionType.Cheapest,
    comparePriceTo: 'competitor',
    isPermanentLink: true,
    minPricingPlanToUse: PricingPlanTypes.Premium,
    entity: 'searchableProducts',
    columns: [
      'title',
      'brand',
      'barcode',
      'sku',
      'cost',
      'externalId',
      'price',
      'compareAtPrice',
      'cheapest price',
      'cheapest competitor',
      'cheapest competitor url',
      'competitiveness',
      'market average',
      'market lowest',
      'market lowest diff percent',
      'market average diff percent',
      'market average diff',
      'market lowest diff',
      'google shopping paid rank',
      'price gaps',
      'competitor-1-name',
      'competitor-1-price',
      'competitor-2-name',
      'competitor-2-price',
      'competitor-3-name',
      'competitor-3-price',
      'competitor-4-name',
      'competitor-4-price',
      'competitor-5-name',
      'competitor-5-price',
      'competitor-6-name',
      'competitor-6-price',
      'competitor-7-name',
      'competitor-7-price',
      'competitor-8-name',
      'competitor-8-price',
      'competitor-9-name',
      'competitor-9-price',
      'competitor-10-name',
      'competitor-10-price',
      'competitor-11-name',
      'competitor-11-price',
    ],
  },
  {
    title: 'Map Monitoring',
    reportType: ReportType.PriceMAP,
    dateResolution: null,
    setPriceTo: null,
    margin: 1,
    marginType: PricingMarginType.Currency,
    positionOperatorType: PositionOperatorType.Equal,
    positionType: PricingPositionType.Cheapest,
    comparePriceTo: 'competitor',
    entity: 'searchableProducts',
    isPermanentLink: false,
    minPricingPlanToUse: PricingPlanTypes.Business,
    columns: [
      'title',
      'price',
      'barcode',
      'sku',
      'externalId',
      'cheapest price',
      'cheapest competitor',
      'competitor-1-name',
      'competitor-1-price',
      'competitor-1-margin',
      'competitor-2-name',
      'competitor-2-price',
      'competitor-2-margin',
      'competitor-3-name',
      'competitor-3-price',
      'competitor-3-margin',
      'competitor-4-name',
      'competitor-4-price',
      'competitor-4-margin',
      'competitor-5-name',
      'competitor-5-price',
      'competitor-5-margin',
      'competitor-6-name',
      'competitor-6-price',
      'competitor-6-margin',
      'competitor-7-name',
      'competitor-7-price',
      'competitor-7-margin',
      'competitor-8-name',
      'competitor-8-price',
      'competitor-8-margin',
      'competitor-9-name',
      'competitor-9-price',
      'competitor-9-margin',
      'competitor-10-name',
      'competitor-10-price',
      'competitor-10-margin',
      'competitor-11-name',
      'competitor-11-price',
      'competitor-11-margin',
    ],
  },
];
